import Avatar from "@/assets/images/decorate/user_avatar.png"
import Background from "@/assets/images/decorate/user_bg.png"
import { apiGetAccessToken, apiGetTokenByCode, apiTokenGet } from "~/api/site"

export default defineNuxtPlugin((nuxtApp) => {
    if (nuxtApp.payload.error) {
        return {}
    }

    const code = ref<string | null>()
    const token = useLocalStorage<string | null>("ly_token", null)
    const teanatid = useLocalStorage<string | null>("teanatid", "mrr2u5lq")
    const theme = useLocalStorage<{ id: number; title: string } | null>("theme", null, {
        serializer: {
            read: (v: any) => (v ? JSON.parse(v) : null),
            write: (v: any) => JSON.stringify(v),
        },
    })
    const site = ref<LyBase.Site | null>()
    const config = useRuntimeConfig().public

    addRouteMiddleware(
        "site",
        async (to) => {
            if (to.query.code) {
                code.value = to.query.code as string
            }
            if (config.mode === "dev") {
                code.value = "ys_store_pos"
            }
            if (!token.value && code.value) {
                try {
                    const { response } = await apiGetTokenByCode(code.value)
                    token.value = response
                } catch (error) {
                    throw createError({
                        statusMessage: "Please revisit the system",
                        statusCode: 401,
                    })
                }
            }
            // if (to.query.teanatid) {
            //     teanatid.value = to.query.teanatid as string
            // }
            if (!teanatid.value) {
                useMessage().error("缺少参数teanatid")
                return
            }
            if ((to.meta.layout && to.meta.layout != "default") || to.meta.site) {
                if (to.meta.theme) {
                    if (!theme.value) {
                        navigateTo("/diy")
                    }
                }
                if (!site.value) {
                    const { response } = await apiTokenGet(teanatid.value)
                    response.avatar = Avatar
                    response.background = Background
                    site.value = response
                }
            }
        },
        { global: true },
    )

    return {
        provide: {
            site: {
                teanatid,
                theme,
                site,
                token,
            },
        },
    }
})
